import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Provider from 'react-redux/lib/components/Provider';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { lightBlue400, red400 } from 'material-ui/styles/colors';
import Main from './Main';
import Header from './Header';
import Footer from './Footer';
import configureStore from '../store';
import HeaderNew from "./HeaderNew";
import FooterNew from "./FooterNew";
// import {Button} from "react-bootstrap";

const muiTheme = getMuiTheme({
  fontFamily: 'Open Sans',
  palette: {
    primaryColor: lightBlue400,
    secondaryColor: red400,
  },
});

const store = configureStore();

class App extends React.Component {
render(){
  return(
      <MuiThemeProvider muiTheme={muiTheme}>
        <Provider store={store}>
          <BrowserRouter>
            <div>
              <HeaderNew />
              {/*<Header />*/}
              <div id="main-home" />
              {/*<Pricing />*/}
              <Main />
              {/*<Footer/>*/}
              <FooterNew />
            </div>
          </BrowserRouter>
        </Provider>
      </MuiThemeProvider>
  );
}
}


export default App;



// WEBPACK FOOTER //
// ./src/components/App.js